import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PromocodeBase } from '../../promocode-base';
import { OriginalityService } from '../../../../services/originality.service';
import { first } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { MessageService } from 'primeng';

@Component({
  selector: 'smart-discount-school-section',
  templateUrl: './discount-school-section.component.html',
  styleUrls: ['./discount-school-section.component.scss'],
})
export class DiscountSchoolSectionComponent extends PromocodeBase implements OnInit {

  discountForm: FormGroup;

  loading = false;

  constructor(
    private _fb: FormBuilder,
    private originality: OriginalityService,
    private datePipe: DatePipe,
    private messageService: MessageService
  ) {
    super();
  }

  ngOnInit() {
    this.discountForm = this._fb.group({
      code: ['', [Validators.required]],
      expirationDate: ['', [Validators.required]],
      discount: ['', [Validators.required, Validators.min(1), Validators.max(1000)]]
    });
  }

  submit() {
    this.promocode.code = this.discountForm.get('code').value;
    this.promocode.expirationDatetime = this.datePipe.transform(this.discountForm.get('expirationDate').value, 'yyyy-MM-dd');
    this.promocode.discountPercentage = this.discountForm.get('discount').value;

    this.originality
      .generatePromoCodeForSchool(this.promocode)
      .pipe(first())
      .subscribe({
        next: value => {
          this.messageService.add({severity: 'success', summary: 'Zľavový kód bol úspešne vytvorený.'});
          this.forceRefresh.emit(true);
          this.resetForm();
        },
        error: err => {
          this.messageService.add({severity: 'error', summary: 'Zľavový kód sa nepodarilo vytvoriť.'});
          console.log(err);
        }
      });
  }

  resetForm() {
    this.discountForm.reset();
  }

}
